import { render, staticRenderFns } from "./PageLanding.vue?vue&type=template&id=4eea5ea8&scoped=true&"
import script from "./PageLanding.vue?vue&type=script&lang=ts&"
export * from "./PageLanding.vue?vue&type=script&lang=ts&"
import style0 from "./PageLanding.vue?vue&type=style&index=0&id=4eea5ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea5ea8",
  null
  
)

export default component.exports